import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import '../AdminShared.css';

export default function SubscribersTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      const { data, error } = await supabase
        .from('subscribers')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) setError(error.message);
      else setItems(data);
      setLoading(false);
    })();
  }, []);

  const exportCsv = () => {
    const header = 'email,city,subscribed_at\n';
    const rows = items.map(
      (s) => `${s.email},${s.city || ''},${s.created_at}`
    ).join('\n');
    const blob = new Blob([header + rows], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'subscribers.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="tab-header">
        <h2 className="tab-title">Subscribers</h2>
        {items.length > 0 && (
          <button className="tab-add-btn" onClick={exportCsv}>Export CSV</button>
        )}
      </div>

      {error && <p className="tab-error">{error}</p>}

      {loading ? (
        <p className="tab-status">Loading...</p>
      ) : items.length === 0 ? (
        <p className="tab-status">No subscribers yet.</p>
      ) : (
        <>
          <p className="sub-count">{items.length} total subscriber{items.length !== 1 ? 's' : ''}</p>
          <table className="sub-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>City</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id}>
                  <td>{s.email}</td>
                  <td>{s.city || '—'}</td>
                  <td>{new Date(s.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
